'use client'

import { useFormikContext } from 'formik'
import { Badge } from '@/components/ui/badge'
import { SectionCard } from './fields'
import type { PlanEditorValues } from './model'
import { buildCompactSummary } from './summary-model'

export function PlanSummary() {
  const { values } = useFormikContext<PlanEditorValues>()
  return (
    <SectionCard title="Plan summary">
      <div className="space-y-2">
        <p className="break-words font-semibold">{values.display_name || 'New plan'}</p>
        <div className="flex flex-wrap gap-2">
          <Badge variant="secondary">{values.status}</Badge>
          <Badge variant="outline">{values.billing_channel}</Badge>
        </div>
      </div>
      <dl className="grid grid-cols-2 gap-x-4 gap-y-3 text-sm">
        {buildCompactSummary(values).map(row => (
          <div key={row.label} className="min-w-0">
            <dt className="text-xs text-muted-foreground">{row.label}</dt>
            <dd className="mt-0.5 break-words font-medium">{row.value}</dd>
          </div>
        ))}
      </dl>
    </SectionCard>
  )
}
